import { createContext } from 'react';

interface PdfJob {
  jobId: string;
  fileName: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  progress?: number;
  downloadUrl?: string;
  error?: string;
  metadata?: {
    batchId: number;
    batchNumber: string;
    farmer: string;
    farm: string;
    selectedPlot: string;
    generatedAt: string;
  };
  startTime: Date;
  pollCount: number;
}

export interface PdfStatusContextType {
  jobs: PdfJob[];
  addJob: (
    jobId: string,
    fileName: string,
    metadata?: PdfJob['metadata']
  ) => void;
  removeJob: (jobId: string) => void;
  retryJob: (jobId: string) => void;
  downloadJob: (jobId: string) => void;
  getActiveJobs: () => PdfJob[];
  getCompletedJobs: () => PdfJob[];
  getFailedJobs: () => PdfJob[];
  updateJobStatus: (
    jobId: string,
    updates: Partial<Pick<PdfJob, 'status' | 'progress' | 'downloadUrl' | 'error'>>
  ) => void;
}

export const PdfStatusContext = createContext<PdfStatusContextType | null>(null);